import { Stack } from '../stack/stack.tsx'
import { LoadingSpinner } from './loading-spinner.tsx'

export const LoadingCenter = () => (
  <Stack height="full">
    <LoadingSpinner className="text-brand h-12 w-12 m-auto" />
  </Stack>
)
